import CityModel from "../models/cities";
import LimitedRelationshipModel from "../models/limitedRelationship";
import RelationshipModel from "../models/relationship";
import UnidadeModel from "../models/unidade";
import {
  fetchCities,
  fetchLimitedRelationships,
  fetchRelationships,
  fetchUnidades,
  privateSendForm,
  sendForm,
} from "../provider/api";

export let errorMessage: String;

export async function sendFormFunction(
  cpf: string,
  name: string,
  phone: string,
  cep: string,
  street: string,
  email: string,
  neighborhood: string,
  number: string,
  compliment: string,
  city: number,
  state: number,
  id_clube: number,
  requestDate: string,
  companyId: number,
  categoryId: number,
  groupId: number,
  numContrato: number,
  id_contrato: number,
  dependents: {
    Nome_dependente: string;
    Grau_parentesco: number;
    Telefone_dependente: string;
    CPF_dependente: string;
    Email_dependente: string;
  }[]
) {
  try {
    const responseData = await sendForm(
      cpf,
      name,
      phone,
      cep,
      street,
      email,
      neighborhood,
      number,
      compliment,
      city,
      state,
      id_clube,
      requestDate,
      companyId,
      categoryId,
      groupId,
      numContrato,
      id_contrato,
      dependents
    );

    const holderId = responseData.id;
    console.log(holderId, "idProposta:");

    if (!holderId) {
      console.error("Erro na resposta da API:", responseData.mensagem);
      return { errorMessage: responseData.mensagem };
    }

    return { holderId };
  } catch (error: any) {
    console.error(
      `Erro (${
        error.response?.status || "desconhecido"
      }) ao enviar o formulário`
    );
    console.log("Detalhes do erro:", error);

    return { formId: [] };
  }
}

export async function privateSendFormFunction(
  cnpj: string,
  dataInclusao: Date,
  dataFinalizacao: string | null,
  nome: string,
  cpf: string,
  dataNasc: Date,
  idSexo: number | null,
  email: string,
  cep: string,
  logradouro: string,
  numero: string,
  complemento: string,
  idCidade: number,
  idUf: number,
  telefone: string,
  celular: string,
  idUsuarioProc: number,
  dataProc: string | null,
  selecionar: any,
  bairro: string | null,
  idAssociado: number,
  dependents: {
    Nome_dependente: string;
    Grau_parentesco: number;
    Telefone_dependente: string;
    CPF_dependente: string;
    Email_dependente: string;
  }[]
) {
  try {
    const responseData = await privateSendForm(
      cnpj,
      dataInclusao,
      dataFinalizacao,
      nome,
      cpf,
      dataNasc,
      idSexo,
      email,
      cep,
      logradouro,
      numero,
      complemento,
      idCidade,
      idUf,
      telefone,
      celular,
      idUsuarioProc,
      dataProc,
      selecionar,
      bairro,
      idAssociado,
      dependents
    );

    const holderId = responseData.id;
    console.log(holderId, "idProposta:");

    if (!holderId) {
      console.error("Erro na resposta da API:", responseData.mensagem);
      return { errorMessage: responseData.mensagem };
    }

    return { holderId };
  } catch (error: any) {
    console.error(
      `Erro (${
        error.response?.status || "desconhecido"
      }) ao enviar o formulário`
    );
    console.log("Detalhes do erro:", error);

    return { formId: [] };
  }
}

export async function getUnidades(): Promise<{ unidades: UnidadeModel[] }> {
  try {
    const responseData = await fetchUnidades();

    if (responseData.statusCode && responseData.statusCode !== 200) {
      throw new Error(responseData.message || "Erro ao buscar unidades.");
    }

    const unidades = UnidadeModel.fromApiResponseArray(responseData);
    return { unidades };
  } catch (error: any) {
    console.error(`Erro (${error.response?.status}) ao buscar unidades`);
    console.log(error.toString());
    return { unidades: [] };
  }
}

export async function getCities(): Promise<{
  cities: CityModel[];
  states: Set<string>;
}> {
  try {
    const responseData = await fetchCities();

    if (responseData.statusCode && responseData.statusCode !== 200) {
      throw new Error(responseData.message || "Erro ao buscar municípios.");
    }

    const cities = CityModel.fromApiResponseArray(responseData);
    const states = new Set(cities.map((city) => city.uf!));

    return { cities, states };
  } catch (error: any) {
    console.error(`Erro (${error.response?.status}) ao buscar municípios`);
    console.log(error.toString());
    return { cities: [], states: new Set() };
  }
}

export async function getRelationships(): Promise<{
  relationships: RelationshipModel[];
}> {
  try {
    const responseData = await fetchRelationships();

    if (responseData.statusCode && responseData.statusCode !== 200) {
      throw new Error(
        responseData.message || "Erro ao buscar relacionamentos."
      );
    }

    const relationships = RelationshipModel.fromApiResponseArray(responseData);
    return { relationships };
  } catch (error: any) {
    console.error(`Erro (${error.response?.status}) ao buscar relacionamentos`);
    console.log(error.toString());
    return { relationships: [] };
  }
}

export async function getLimitedRelationships(
  categoryId: string
): Promise<{ relationships: LimitedRelationshipModel[] }> {
  try {
    const responseData = await fetchLimitedRelationships(categoryId);

    if (responseData.statusCode && responseData.statusCode !== 200) {
      throw new Error(
        responseData.message || "Erro ao buscar relacionamentos."
      );
    }

    const relationships =
      LimitedRelationshipModel.fromApiResponseArray(responseData);
    return { relationships };
  } catch (error: any) {
    console.error(`Erro (${error.response?.status}) ao buscar relacionamentos`);
    console.log(error.toString());
    return { relationships: [] };
  }
}
